import { CountryPhoneInput, CountryPhoneInputProps } from 'antd-country-phone-input';
import 'antd-country-phone-input/dist/index.css';
import { AsYouType, CountryCode, getExampleNumber } from 'libphonenumber-js';
import examples from 'libphonenumber-js/examples.mobile.json';
import { useMemo } from 'react';

const InternationalPhoneInput: React.FC<CountryPhoneInputProps> = ({
  value,
  onChange,
  placeholder,
  ...props
}) => {
  const defaultPlaceholder = useMemo(() => {
    if (value) {
      const countryCode = value.short ? (value.short as CountryCode) : ('BR' as CountryCode);
      const example = getExampleNumber(countryCode, examples)?.nationalNumber;

      if (example) {
        const placeholderAsYouType = new AsYouType(countryCode);
        placeholderAsYouType.input(example.toString());
        return placeholderAsYouType.getTemplate();
      }
    }
    return '(xx) xxxxx-xxxx';
  }, [value]);

  const asYouType = new AsYouType({
    defaultCountry: value ? (value.short as CountryCode) : ('BR' as CountryCode),
    defaultCallingCode: value ? value.code?.toString() : '55',
  });

  return (
    <CountryPhoneInput
      type="tel"
      inline
      placeholder={placeholder || defaultPlaceholder}
      value={{
        ...value,
        // After formatting the number with AsYouType, remove non-digit characters after the last number to avoid problems when using backspace
        phone: asYouType.input(value?.phone || '').replace(/\D+$/g, ''),
      }}
      onChange={(value) => {
        onChange?.({
          ...value,
          // Remove all non-digit characters and leading zeros from the input value
          phone: value.phone ? value.phone?.replace(/\D/g, '').replace(/^0+/g, '') : undefined,
        });
      }}
      {...props}
    />
  );
};

export default InternationalPhoneInput;
